<div class="list-popup">
    <div class="header">{{ data()?.length + " salg" }}</div>
    <div>
        <div class="item-wrapper">
            @for(sale of sales(); track $index){
            <commercial-sale-item [sale]="sale"></commercial-sale-item>
            }
            <div class="bottom-margin"></div>
        </div>
    </div>
</div>
